import { render, staticRenderFns } from "./ProductsSelectItem.vue?vue&type=template&id=8e459644&scoped=true"
import script from "./ProductsSelectItem.vue?vue&type=script&lang=js"
export * from "./ProductsSelectItem.vue?vue&type=script&lang=js"
import style0 from "./ProductsSelectItem.vue?vue&type=style&index=0&id=8e459644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e459644",
  null
  
)

export default component.exports